export default __webpack_public_path__ + "static/media/regulatory--pedestrians-only--g3.76d6977a.png";